import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {L10nModule} from '../translate';
import {TextHidingWithTooltipDirective} from './text-hiding-with-tooltip.directive';
import {TooltipBalloonComponent} from './tooltip-balloon';
import {TooltipL10nDirective} from './tooltip-l10n.directive';
import {TooltipDirective} from './tooltip.directive';

@NgModule({
    imports: [
        CommonModule,
        L10nModule
    ],
    declarations: [
        TooltipBalloonComponent,
        TooltipDirective,
        TooltipL10nDirective,
        TextHidingWithTooltipDirective
    ],
    exports: [
        TooltipDirective,
        TooltipL10nDirective,
        TextHidingWithTooltipDirective
    ]
})
export class TooltipModule {}
